// extracted by mini-css-extract-plugin
module.exports = {"feesLabel":"NetSheetAddItemModal_feesLabel__3vguM"};